import { render } from "./RFlex.vue?vue&type=template&id=e5e00f28"
import script from "./RFlex.vue?vue&type=script&lang=js"
export * from "./RFlex.vue?vue&type=script&lang=js"

import "./RFlex.vue?vue&type=style&index=0&id=e5e00f28&lang=css"
script.render = render

export default script